import { SCREEN_WIDTH } from 'constants/ui';

export const getCurrentWidthAndHeight = () => [window.innerWidth, window.innerHeight];

export const calculateScreenInfo = windowWidth => ({
  isMobile: windowWidth < SCREEN_WIDTH.M,
  isTablet: windowWidth >= SCREEN_WIDTH.M && windowWidth < SCREEN_WIDTH.L,
  isDesktop: windowWidth >= SCREEN_WIDTH.L,
});
